import { deleteMonthLogic } from "./ManageData.logic";
// import { saveSelectedManageData } from "../Infrastructure/ManageData.store";

export async function deleteMonth(id, id_month) {
  await deleteMonthLogic(id, id_month);
}
